import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'loading-placeholder',
  templateUrl: './loading-placeholder.component.html',
  styleUrls: ['./loading-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingPlaceholderComponent {
  @Input() centered = false;
  @Input() section: number | number[] = [1, 2, 3];
  @Input() showEllipse = true;
  @Input() loadingPlaceholderText = '';

  shouldShow(showSection: number) {
    if (this.section === 0) return true;
    return Array.isArray(this.section)
      ? this.section.includes(showSection)
      : this.section === showSection;
  }
}
